import { render, staticRenderFns } from "./FiltersForAdmin.vue?vue&type=template&id=3e3bf47c&scoped=true&"
import script from "./FiltersForAdmin.vue?vue&type=script&lang=js&"
export * from "./FiltersForAdmin.vue?vue&type=script&lang=js&"
import style0 from "./FiltersForAdmin.vue?vue&type=style&index=0&id=3e3bf47c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3bf47c",
  null
  
)

export default component.exports